import { get } from 'lodash';
var IdentitySourceManager = /** @class */ (function () {
    function IdentitySourceManager(identityConfig) {
        this.identityConfig = identityConfig;
    }
    IdentitySourceManager.prototype.fetchIdentityData = function (dataSource) {
        var data = {
            identity: undefined,
            properties: undefined
        };
        if (!this.identityConfig)
            return data;
        if (this.identityConfig.identity) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var identityValue = get(dataSource, this.identityConfig.identity);
            // warn if path doesn't exist
            if (!identityValue) {
                console.warn("Samelogic: unable to get identity value from ".concat(this.identityConfig.identity));
            }
            else {
                // warn if identity object is invalid
                var identityType = typeof identityValue;
                if (identityType !== 'string' && identityType !== 'number') {
                    console.warn("Samelogic: value of identity ".concat(this.identityConfig.identity, " should be a string or a number. Got ").concat(String(identityValue)));
                }
                data.identity = String(identityValue);
            }
        }
        if (this.identityConfig.properties) {
            var props = {};
            for (var _i = 0, _a = this.identityConfig.properties; _i < _a.length; _i++) {
                var prop = _a[_i];
                var propName = prop.name;
                var propPath = prop.variable;
                if (propPath) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    var propValue = get(dataSource, propPath);
                    // warn if path doesn't exist
                    if (!propValue) {
                        console.warn("Samelogic: unable to get prop ".concat(propName));
                    }
                    // warn if identity object is invalid
                    var propType = typeof propValue;
                    if (propType === 'object') {
                        console.warn("Samelogic: value of prop ".concat(propName, " should not be an object"));
                    }
                    props[String(propName)] = propValue;
                }
            }
            data.properties = props;
        }
        return data;
    };
    return IdentitySourceManager;
}());
export { IdentitySourceManager };
//# sourceMappingURL=IdentitySourceManager.js.map